/**
 * AutoTextTranslator — DISABLED.
 * Lasciato come no-op finché il sistema non viene riprogettato in modo più sicuro
 * (era troppo aggressivo: MutationObserver su tutto il body causava rallentamenti
 * e conflitti con il re-render di React).
 */
export default function AutoTextTranslator() {
  return null;
}
